import httpClient from 'api/httpClient';
import {
  Pagination,
  RequestParams,
  Searchable,
} from 'router/subrouters/Dashboard/pages/hooks/usePaginatedItems';

class SearchStoreProduct implements Searchable {
  keys() {
    return ['skuNo', 'storeNo'] as const;
  }
}
export type StoreInventoryProduct = {
  productId: string;
  skuNo: string;
  storeNo: number;
  numberOfBins: number;
  total: number;
  availableToSell: number;
  notAvailableToSell: number;
  availableInventoryElsewhere: number;
  customerFacingReplenishment: number;
} & SearchStoreProduct & { id: string; storeNo: string };

const getStoreProductInventory = (
  params: RequestParams<StoreInventoryProduct>,
): Promise<Pagination<StoreInventoryProduct>> =>
  httpClient
    .get('store-inventory', { params })
    .then((response) => response.data);

const getStoreProductInventoryView = (
  params: RequestParams<StoreInventoryProduct>,
): Promise<Pagination<StoreInventoryProduct>> => {
  const storeNo = params?.storeNo;
  return httpClient
    .get(`store-inventory/${storeNo}/view`, { params })
    .then((response) => response.data);
};

export default { getStoreProductInventory, getStoreProductInventoryView };
